// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CJF7","footer":"styles_footer__3ki0N","passCodeTooltip":"styles_passCodeTooltip__2FMqu"};